import {entity} from "../../infra/api/rpc/api";

export class CustomerBlackList {

    public static from(from: entity.CustomerBlackList): CustomerBlackList {
        return new CustomerBlackList(
            from.customerID,
            from.domains,
        )
    }

    constructor(
        public readonly customerId: string,
        public readonly domains: string[],
    ) {}

}


// WEBPACK FOOTER //
// ./src/domain/model/customer_black_list.ts